import { ThemeConfig } from "antd";

export const antdThemeConfig: ThemeConfig = {
  token: {
    fontFamily: "Open Sans",
    colorPrimary: "#DC3B41",
    colorError: "#ef2926",
    borderRadius: 4,
  },
  components: {
    Select: {
      controlHeightLG: 44,
      controlItemBgActive: "#feeae9",
      colorBgContainer: "#F8FAFC",
    },
    DatePicker: {
      controlHeightLG: 44,
    },
    Button: {
      controlHeightLG: 48,
      controlHeightSM: 24,
      controlHeight: 40,
      primaryShadow: "shadow-none",
      defaultShadow: "shadow-none",
      fontWeight: 600,
    },
    Carousel: {
      dotWidth: 210,
      dotActiveWidth: 210,
    },
    Menu: {
      padding: 8,
      itemMarginInline: 0,
    },
    Typography: {
      fontSizeHeading1: 36,
      fontSizeHeading2: 28,
      fontSizeHeading3: 22,
      fontSizeHeading4: 18,
      fontSizeHeading5: 16,
      titleMarginBottom: 0,
    },
    Input: {
      controlHeightLG: 44,
      colorBgContainer: "#F8FAFC",
    },
    InputNumber: {
      controlHeightLG: 44,
      colorBgContainer: "#F8FAFC",
    },
  },
};
